import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { PersonInsightsData } from './PersonInsightsData';
import { GlobalService } from 'src/app/_services/global.service';
import { AggregationService } from '../_services/aggregation.service';
import { environment } from '../../environments/environment';
import { LocalStorageService } from '../_services/local-storage.service';

import {Subscription} from 'rxjs'
import { LoaderEventsService } from '../_services/loader-events.service';
import { LoaderType } from '../enums/LoaderType';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { PersonSearchService } from '../_services/person-search.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';

declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009"
}

@Component({
  selector: 'app-person-search-insights',
  templateUrl: './person-search-insights.component.html',
  styleUrls: ['./person-search-insights.component.scss']
})
export class PersonSearchInsightsComponent implements OnInit, OnDestroy {

  @Input() searchHistoryRegion: any;
  personInsightsData: PersonInsightsData = {};
  currentCompanyInformation: CurrentCompanyInformation = {};
  subs: Subscription[] = [];
  @Output() insightsEvents= new EventEmitter<{action : string, data: any}>();
  @Input() similarContinent: string;
  similarType: string;


  // Note : localstorageservice is being used with the help of bind method in load google maps method
  constructor(
    private aggregationService: AggregationService,
    private localstorageservice: LocalStorageService,
    private loaderEventService: LoaderEventsService,
    private personsearchservice: PersonSearchService, 
    private filterDataHandlerService: FilterDataHandlerService,
    private similarCandidateService: SimilarCandidateService,
    private route: ActivatedRoute
  ) {
    this.aggregationService.getTotalAggs();
  }

  ngOnInit() {
    const insightsDataEvent = this.aggregationService.insightsDataEvent.subscribe(data => {
      this.processIndividualData(data)
    });
    this.subs.push(insightsDataEvent);

    const loaderEvent = this.loaderEventService.loaderEvent.subscribe(event => {
      if (event === LoaderType.INSIGHTS) { this.personInsightsData = {}; }
    });
    this.subs.push(loaderEvent);
    this.similarType = this.route.snapshot.queryParams['type'];

  }

  private processIndividualData(data: any) {
    let agg = data?.data?.aggregations;
    if (data?.status !== "success" || !agg)
      return;

    const key = Object.keys(agg)[0];
    data[key] = data?.data?.aggregations[key];
    this.personInsightsData = this.aggregationService.processAggregationResponse(
      this.personInsightsData, data, { aggregatetype: key }
    );

    key === "location" &&  setTimeout(() => this.loadGoogleMap(this.personInsightsData), 100);
    if((this.personInsightsData && this.personInsightsData.topLocations) && ( this.personInsightsData && this.personInsightsData.dataSourceCurrentCompany && this.personInsightsData.dataSourceCurrentCompany.data )
    && (this.personInsightsData && this.personInsightsData.currentIndustry)
      && (this.personInsightsData && this.personInsightsData.school ) &&
      (this.personInsightsData && this.personInsightsData.fieldOfStudy ) && 
      (this.personInsightsData && this.personInsightsData.skills ) && 
      (this.personInsightsData && this.personInsightsData.titles ) && 
      (this.personInsightsData && this.personInsightsData.dataSourceCurrentExperience && this.personInsightsData.dataSourceCurrentExperience.data) &&
      (this.personInsightsData && this.personInsightsData.dataSourceExpInCurrentRole && this.personInsightsData.dataSourceExpInCurrentRole.data) && 
      (this.personInsightsData && this.personInsightsData.dataSourceSeniority && this.personInsightsData.dataSourceSeniority.data)) {
        let eventData = { action: "aidata", data: this.personInsightsData }
      this.insightsEvents.emit(eventData);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  loadGoogleMap(personInsightsData: PersonInsightsData) {
    function drawMarkersMap() {
      try {
        var data = google.visualization.arrayToDataTable(
          personInsightsData.dataSourceWorkCountry
        );
        const continent = this.filterDataHandlerService.isRedirectFromTalentInsightsPage?this.localstorageservice.getItem("talentRegion"):this.searchHistoryRegion? this.searchHistoryRegion :this.similarCandidateService.isListingCalledFromSimilarCandidate ? this.similarContinent: this.localstorageservice.getItem("region");
        var options = {
          region: (this.filterDataHandlerService.isRedirectFromCompanyInsightsPage || this.similarType == 'similar-candidate-resume-upload')? "world" : `${
            CONTINENT_MAP[continent]
          }`,
          displayMode: "markers",
          colorAxis: { colors: ["#ff7f7f", "#ffff32", "#4292ff"] },
        };
        const container = document.getElementById("workCountryChartDD");
        var chart = new google.visualization.GeoChart(container);
        chart.draw(data, options);
      } catch (error) {
        console.log('error in data visualisation in drawMakersMap :: ', error.message);
      }
    }

    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  getIndustryIcon(industryName) {
    let iconName = GlobalService.getIndustryIcon(industryName);
    return `text-webbtree-black fa-solid fa-${iconName}`;
  }

  getCompanyInfo(data: any) {
    let pastCompanyData = data;

    this.currentCompanyInformation['name'] = pastCompanyData?.name;
    this.currentCompanyInformation['industry'] = pastCompanyData?.industry;
    this.currentCompanyInformation['linkedin_url'] = pastCompanyData?.linkedin_url;
    this.currentCompanyInformation['location'] = pastCompanyData?.location?.name;
    this.currentCompanyInformation['size'] = pastCompanyData?.size;
    this.currentCompanyInformation['website'] = pastCompanyData?.website;
    this.currentCompanyInformation['companylogo'] = pastCompanyData.companylogo;
    this.currentCompanyInformation['tags'] = pastCompanyData.tags;
    this.currentCompanyInformation['id'] = pastCompanyData.id;
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param data
   */
  handleRedirection(type: string, data: any) {  
    this.handleChildEvents('redirect');
    this.filterDataHandlerService.setPersonSearchListingInsightsFilter(type, data);
  }

  /**
   * Handle fusion chart click
   * @param event 
   * @param chartName 
   */
  fusionChartsClickHandler(event: any, chartName: string) {
    event.eventObj.preventDefault();
    event.eventObj.stopPropagation();
    event.eventObj.detachHandler();
    const data = chartName == 'yearsofexperience' || chartName == 'currentyearsofexperience' ? event.dataObj.categoryLabel.match(/\d+/)[0] : event.dataObj.categoryLabel;

    this.handleRedirection(chartName, data);
  }

   /**
   * Handles all child events
   * @param action type of action
   */
   handleChildEvents(action: string) {
    let eventData = { action: action, data: {} }
   
    this.insightsEvents.emit(eventData)
  }

}
